import { useMemo } from 'react';
import costcoLogo from '../assets/figo-costco.svg';

const PARTNER_GUIDS = {
  costco: '4BC8B4C4-E147-41F8-8E96-B2E693CC2AD9'
};

export const usePartnerData = (guid) => {
  const logo = useMemo(() => {
    if (guid === PARTNER_GUIDS.costco) {
      return costcoLogo;
    }
    return null;
  }, [guid]);

  return { logo };
};
